// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"eeae1187","651":"9320ff01"}[chunkId] + ".chunk.css";
};